export default "__VITE_ASSET__CZ5aThXX__"